// LogoutButton.tsx
import React from 'react';
import { useRouter } from 'next/navigation';
import { FaSignOutAlt } from 'react-icons/fa'

const LogoutButton = () => {
  const router = useRouter();

  const handleLogout = () => {
    localStorage.removeItem('jwt-token'); // Remove login state from local storage
    localStorage.removeItem('isLoggedInAsGuest')
    // alert("Logged out!")
    // router.push('/'); // Redirect to login page after logout
    router.push('/login')
  };

  return (
  <>
    <button
    className="flex space-x-4 items-center text-gray-500 pl-4 text-sm"
    onClick={handleLogout}
    // className="bg-red-200 text-gray-200 text-sm font-semibold py-2 px-2 rounded-md hover:bg-red-700 transition duration-200"
  >
    Logout&nbsp;&nbsp;<FaSignOutAlt />
  </button>
  </>
  );
};

export default LogoutButton;
